import React, { useState, useEffect } from 'react';
import '../styles/AboutHero.css';
import QuoteModal from './QuoteModal';

// Import images for right side slider
import img1 from '../assets/bg1.png';
import img2 from '../assets/bg2.png';
import img3 from '../assets/bg3.png';
import img4 from '../assets/bg4.png';
import img5 from '../assets/bg5.png';


const AboutHero = () => {

  const [currentSlide, setCurrentSlide] = useState(0);
  const [fade, setFade] = useState(true);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);


  /* ==========================================
     QUOTE MODAL FUNCTIONS
  ========================================== */

  const openQuoteModal = () => {
    setIsQuoteModalOpen(true);
  };


  const closeQuoteModal = () => {
    setIsQuoteModalOpen(false);
  };


  /* ==========================================
     RIGHT SIDE SLIDER IMAGES
  ========================================== */

  const rightImages = [
    { id: 1, image: img1 },
    { id: 2, image: img2 },
    { id: 3, image: img3 },
    { id: 4, image: img4 },
    { id: 5, image: img5 },
  ];


  /* ==========================================
     AUTO SLIDER
  ========================================== */

  useEffect(() => {

    const interval = setInterval(() => {

      setFade(false);

      setTimeout(() => {

        setCurrentSlide(
          (prev) => (prev + 1) % rightImages.length
        );

        setFade(true);

      }, 500);

    }, 5000);


    return () => clearInterval(interval);

  }, [rightImages.length]);


  return (

    <>

      <section
        id="about-hero"
        className="about-hero-section"
      >


        {/* ==================================
            DECORATIVE BACKGROUND
        ================================== */}

        <div className="about-hero-background">

          <div className="about-hero-overlay"></div>

        </div>


        <div className="about-hero-container">


          {/* ==================================
              LEFT CONTENT
          ================================== */}

          <div className="about-hero-content">


            {/* WELCOME BADGE */}

            <div className="about-hero-badge">

              <span className="about-hero-badge-text">
                Welcome to Preferred Audiology
              </span>

            </div>


            {/* COMPANY TAGLINE */}

            <div
              className="about-hero-brand-tagline"
              aria-label="Hear More, Spend Less"
            >

              <span className="about-hero-brand-tagline-main">
                HEAR MORE,
              </span>

              <span className="about-hero-brand-tagline-accent">
                SPEND LESS
              </span>

            </div>


            {/* MAIN TITLE */}

            <h1 className="about-hero-title">

              Trusted & Reliable

              <br />

              <span className="about-hero-highlight">
                Hearing Aid Manufacturer
              </span>

            </h1>


            {/* DESCRIPTION */}

            <p className="about-hero-description">

              We are on a mission to disrupt the hearing aid industry
              with affordable, high-quality solutions and innovative
              concepts like Instant Service & Replacement and BYOB
              (Build Your Own Brand) program.

            </p>


            {/* ==================================
                FEATURES
            ================================== */}

            <div className="about-hero-features">


              <div className="about-hero-feature">

                <span
                  className="about-hero-feature-icon"
                  aria-hidden="true"
                >
                  ✓
                </span>

                <span>
                  Made in India
                </span>

              </div>


              <div className="about-hero-feature">

                <span
                  className="about-hero-feature-icon"
                  aria-hidden="true"
                >
                  ✓
                </span>

                <span>
                  ISO13485:2016 Certified Company
                </span>

              </div>


              <div className="about-hero-feature">

                <span
                  className="about-hero-feature-icon"
                  aria-hidden="true"
                >
                  ✓
                </span>

                <span>
                  Pan-India Support
                </span>

              </div>


            </div>


            {/* ==================================
                CTA BUTTONS
            ================================== */}

            <div className="about-hero-buttons">


              <a
                href="#our-story"
                className="about-hero-btn-primary"
              >

                Discover Our Story

                <svg
                  className="about-hero-btn-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >

                  <path
                    d="M5 12H19M19 12L13 6M19 12L13 18"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                </svg>

              </a>


              <button
                type="button"
                onClick={openQuoteModal}
                className="about-hero-btn-secondary"
              >

                Partner With Us

              </button>


            </div>


            {/* ==================================
                ESTABLISHMENT INFO
            ================================== */}

            <div className="about-hero-stats">

              <div className="about-hero-stat">

                <span className="about-hero-stat-number">
                  Est. 2026
                </span>

                <span className="about-hero-stat-label">
                  Year of Establishment
                </span>

              </div>

            </div>


          </div>


          {/* ==================================
              RIGHT IMAGE SLIDER
          ================================== */}

          <div className="about-hero-image-wrapper">

            <div className="about-hero-image-container">


              {rightImages.map((img, index) => (

                <div
                  key={img.id}
                  className={`
                    about-hero-slide-image
                    ${index === currentSlide ? 'active' : ''}
                    ${
                      fade && index === currentSlide
                        ? 'fade-in'
                        : ''
                    }
                  `}
                >

                  <img
                    src={img.image}
                    alt={`Preferred Audiology Slide ${index + 1}`}
                    className="about-hero-image"
                  />

                </div>

              ))}


            </div>

          </div>


        </div>

      </section>


      {/* ==================================
          QUOTE MODAL
      ================================== */}

      <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={closeQuoteModal}
      />


    </>

  );

};


export default AboutHero;